import React, { useState, useEffect } from "react";
import axios from "axios";
import uuid from "react-uuid";

export const ViewBalance = () => {
  const [balance, setBalance] = useState([]);
  const [acno, setAcno] = useState("");
  const [acc, setAcc] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = async () => {
    try {
      const res = await axios.get("http://localhost:5001/accounts");
      console.log("Account details:", res.data);
      setAcc(res.data);
    } catch (error) {
      console.error("Error fetching accounts:", error);
      setError("Failed to load account details. Please try again.");
    }
  };

  const handleClick = async () => {
    if (!acno || acno === "default") {
      setError("Please select an account number.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      let data = {
        acc: acno,
      };
      
      console.log("Fetching balance for:", data);
      const res = await axios.post("http://localhost:5001/balance", {
        data: data,
      });

      console.log("Balance details:", res.data);
      setBalance(res.data);
      document.getElementById("balRes").style.display = "block";
    } catch (error) {
      console.error("Error fetching balance:", error);
      setError("Failed to fetch balance. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main-data">
      <div className="data-form">
        <h2>View Account Balance</h2>
        <p>Select your account to view the current balance and account details.</p>
        
        <div className="form-group">
          <label htmlFor="account-no">Account Number</label>
          <select
            name="accounts"
            id="acc"
            onChange={(e) => setAcno(e.target.value)}
            value={acno}
            disabled={isLoading}
          >
            <option value="default">-- Select account --</option>
            {acc.map((acn) => (
              <option key={uuid()} value={acn.account_number}>
                {acn.account_number}
              </option>
            ))}
          </select>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <button onClick={handleClick} disabled={isLoading || !acno || acno === "default"}>
          {isLoading ? "Loading..." : "View Balance"}
        </button>
      </div>

      <div id="balRes" className="data-result" style={{ display: "none" }}>
        {balance.map((option) => (
          <div key={uuid()} className="balance-card">
            <h3>Account Details</h3>
            <div className="balance-info">
              <div className="info-row">
                <label>Account Holder:</label>
                <span>{option.account_holder_name}</span>
              </div>
              <div className="info-row">
                <label>Account Number:</label>
                <span>{option.account_number}</span>
              </div>
              <div className="info-row">
                <label>Account Type:</label>
                <span>{option.account_type}</span>
              </div>
              <div className="info-row balance-row">
                <label>Current Balance:</label>
                <span className="balance-amount">₹{option.balance}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewBalance;
